/**
 * Handlebars if helper with condition.
 *
 * @param v1        The first value to be compared.
 * @param operator  The operand to perform on the two given values.
 * @param v2        The second value to be compared
 * @param options   The current handlebars object.
 * @param this   The current handlebars this.
 * @returns {*}
 */
export function ifCond(v1: any, operator: any, v2: any, options: any) {
    switch (operator) {
        case '==':
            // tslint:disable-next-line:triple-equals
            return (v1 == v2) ? options.fn(this) : options.inverse(this);
        case '===':
            return (v1 === v2) ? options.fn(this) : options.inverse(this);
        case '<':
            return (v1 < v2) ? options.fn(this) : options.inverse(this);
        case '<=':
            return (v1 <= v2) ? options.fn(this) : options.inverse(this);
        case '>':
            return (v1 > v2) ? options.fn(this) : options.inverse(this);
        case '>=':
            return (v1 >= v2) ? options.fn(this) : options.inverse(this);
        case '&&':
            return (v1 && v2) ? options.fn(this) : options.inverse(this);
        case '||':
            return (v1 || v2) ? options.fn(this) : options.inverse(this);
        default:
            return options.inverse(this);
    }
}
